var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-options-component",attrs:{"id":"header_options_component"}},[_c('div',{staticClass:"header-options-inner"},[_c('ul',{staticClass:"header-options-list"},[_c('li',[_c('header-options-signout')],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3c8caf78","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/partials/header/middlebar/HeaderOptions.vue
// module id = R4Tz
// module chunks = 0